module.exports = __webpack_public_path__ + "services-large-duo.jpg?da94d080fdbfa4d6a15ac479c98dd69f";


//////////////////
// WEBPACK FOOTER
// ./src/images/services-large-duo.jpg
// module id = 301
// module chunks = 0